<template>
    <app-dialog :title="tb('Condições gerais')" :subtitle="tb('Consulte as condições gerais da plataforma myProvet')" v-bind="$attrs" @input="onDialogInput">
        <template v-slot:content>
            <v-progress-circular v-if="!generalConditions" indeterminate></v-progress-circular>

            <p v-else class="font-size-md mx-1 description-text" v-html="tHtml(generalConditions)"></p>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text class="myprovet-btn-ok" @click="onCloseDialog" data-cy="app-dialog-confirm-btn">{{ tb('Fechar') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { axios } from '@/Services/Backend';

export default {
    props: {
        //
    },

    data() {
        return {
            generalConditions: null,
        };
    },

    created() {
        axios
            .get('/api/general-conditions')
            .then((response) => {
                this.generalConditions = response.data;
            })
            .catch((error) => {
                this.$emit('onCancel', false);
                this.showError(this.$t('toasts.generalConditionsError'));
            });
    },

    methods: {
        onCloseDialog() {
            this.$emit('onCancel', false);
        },
        onDialogInput(event) {
            if (!event) {
                this.$emit('onCancel', false);
            }
        },
    },
};
</script>
